var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import LoadingOverlay from 'react-loading-overlay-ts';
import { Spin } from 'antd';
import ReturnV2 from '../components/ReturnV2';
import BetaGateNotice from '../components/BetaGateNotice';
import { useReceivingPutawayBetaGate } from '../utils/betaAccess';
var ReturnV2Screen = function () {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var gate = useReceivingPutawayBetaGate();
    return (_jsx(LoadingOverlay, __assign({ active: isLoading, spinner: _jsx(Spin, {}, void 0) }, { children: _jsx(Sidebar, __assign({ setIsLoading: setIsLoading }, { children: gate === 'allowed' ? (_jsx(ReturnV2, { setIsLoading: setIsLoading }, void 0)) : (_jsx("div", __assign({ className: 'px-4 sm:px-8 lg:px-16 pt-3 pb-16 h-screen w-full sm:w-4/5 md:w-3/5 lg:w-2/5 mx-auto' }, { children: _jsx("div", __assign({ className: 'bg-white p-5 rounded-lg shadow-sm' }, { children: _jsx(BetaGateNotice, { gate: gate }, void 0) }), void 0) }), void 0)) }), void 0) }), void 0));
};
export default ReturnV2Screen;
